/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkValidResetLink, isLinkValid, login, reset_password, UserDetails } from '../../redux/actions/authActions';
import { TextField, Button, CircularProgress, Alert, Container, Box, Typography } from '@mui/material';
import Loading from '../Loading';
import PageLoaderComp from '../pageLoaderComp';
import { Navigate, useNavigate,Link,useParams   } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import './Styles.scss';

const ResetPasswordComp = () => {

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };



  const [showPassword2, setShowPassword2] = React.useState(false);

  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  const handleMouseDownPassword2 = (e) => {
    e.preventDefault();
  };





  const [formData, setFormData] =useState({ confirm_password: '', password: '',code:""});
  const [errors, setErrors] = useState({ confirm_password: '', password: '' });
  const [isValid, setIsValid] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { loading,pageloading, error,message,user,isLoggedIn,auth_token } = useSelector((state) => state.auth);
  const handleChange = (e) => {
    const {name,value}= e.target;
    setFormData(formData=>({...formData,[name]:value}));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let valid = true;

    if (!formData.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: 'Password is required' }));
      valid = false;
    }
    
    if (!formData.confirm_password) {
      setErrors((prevErrors) => ({ ...prevErrors, confirm_password: 'Confirm password is required' }));
      valid = false;
    }
    if (formData.password !== formData.confirm_password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: '', confirm_password: 'Password does not match!' }));
      valid = false;
    }

    if (valid) {
      // Handle form submission
      // console.log('Form submitted', formData);
      dispatch(reset_password(formData.code, formData.password)); 
     
    }    
  };  
  useEffect(() => {
    setFormData(formData=>({...formData,"code":params.code }));
    const validateLink = async () => {
        const data = await dispatch(checkValidResetLink(params.code));
        // console.log("validateLink",data); // Use the returned data
        setIsValid(data.success);
        if(!data.success){
          navigate("/forgot-password");
        }
    };
    validateLink();
}, [params.code, dispatch]);
  
  useEffect(()=>{
      if(auth_token){
        dispatch(UserDetails());
        navigate("/home"); 
      }
  },[auth_token])
  return (
      
    <Box>
        {
            pageloading?<PageLoaderComp />:""
        }
        
        <Box
        className="loginMain"
        >
          <Box className="loginBoxInn">
            <Typography component="h1" variant="h4" mb={2}>
                Reset Password
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate gap={'15px'} display={'flex'} flexDirection={'column'} width={'100%'}>                
            <FormControl variant="outlined">
              <InputLabel htmlFor="password">Password</InputLabel>
              <OutlinedInput
                id="password"
                required
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                value={formData.password}
                name="password"
                onChange={(e) => {
                  handleChange(e);
                }}
                error={!!errors.password}
                helperText={errors.password}
                endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
              />
            </FormControl>


            <FormControl variant="outlined">
              <InputLabel htmlFor="confirm_password">Confirm Password</InputLabel>
              <OutlinedInput
                id="confirm_password"
                required
                type={showPassword2 ? 'text' : 'password'}
                autoComplete="confirm_password"
                value={formData.confirm_password}
                name="confirm_password"
                onChange={(e) => {
                  handleChange(e);
                }}
                error={!!errors.confirm_password}
                helperText={errors.confirm_password}
                endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle confirm password visibility"
                    onClick={handleClickShowPassword2}
                    onMouseDown={handleMouseDownPassword2}
                    edge="end"
                  >
                    {showPassword2 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Confirm Password"
              />
            </FormControl>

                {/* <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="confirm_password"
                label="Confirm Password"
                type={showPassword ? 'text' : 'password'}
                id="confirm_password"
                autoComplete="confirm_password"
                value={formData.confirm_password}
                onChange={(e) => {
                    handleChange(e);
                }}
                error={!!errors.confirm_password}
                helperText={errors.confirm_password}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                /> */}
                <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                >
                {loading ?  <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Login'}
                </Button>
                <Box textAlign={"right"} style={{ color: '#8BAF91' }}>
                  <Link to="/forgot-password" style={{ color: '#8BAF91' }} variant="body2">
                      Forgot password?
                  </Link>
                </Box>
            </Box>
            </Box>
        </Box>
    </Box>
  );
};

export default ResetPasswordComp;
